module.exports = __webpack_public_path__ + "static/img/28@2x.f29e8e8d.png";